import {
  FETCH_ALLOWANCES,
  FETCH_ALLOWANCES_SUCCESS,
  FETCH_ALLOWANCES_FAILURE,
  CREATE_ALLOWANCE_REQUEST,
  CREATE_ALLOWANCE_SUCCESS,
  CREATE_ALLOWANCE_FAILURE,
  DELETE_ALLOWANCE,
  DELETE_ALLOWANCE_SUCCESS,
  DELETE_ALLOWANCE_FAILURE,
} from "./actionTypes";

// Fetch Allowances
export const fetchAllowances = (unitId) => ({
  type: FETCH_ALLOWANCES,
  payload: { unitId }
});

export const fetchAllowancesSuccess = (roles) => ({
  type: FETCH_ALLOWANCES_SUCCESS,
  payload: roles,
});

export const fetchAllowancesFailure = (error) => ({
  type: FETCH_ALLOWANCES_FAILURE,
  payload: error,
});


// Create Allowance
export const createAllowanceRequest = (formData, isEdit) => ({
  type: CREATE_ALLOWANCE_REQUEST,
  payload: { formData, isEdit },
});

export const createAllowanceSuccess = (response) => ({
  type: CREATE_ALLOWANCE_SUCCESS,
  payload: response,
});

export const createAllowanceFailure = (error) => ({
  type: CREATE_ALLOWANCE_FAILURE,
  payload: error,
});

// Delete Allowance
export const deleteAllowance = (formdata) => ({
  type: DELETE_ALLOWANCE,
  payload: formdata,
});

export const deleteAllowanceSuccess = (response) => ({
  type: DELETE_ALLOWANCE_SUCCESS,
  payload: response,
});

export const deleteAllowanceFailure = (error) => ({
  type: DELETE_ALLOWANCE_FAILURE,
  payload: error,
});